import { render } from "./social-login.vue?vue&type=template&id=cbaa9ea0"
import script from "./social-login.vue?vue&type=script&lang=js"
export * from "./social-login.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__